import * as cobrancas from '@/api/cobrancas'

const state = {
  list: [],
  filtros: {page: 1},
  countPage: 0,
  listValores: [],
  registros: 0
}

const mutations = {
  SETCOBRANCAS (state, payload) {
    state.list = payload
  },
  SETVALORES (state, payload) {
    state.listValores = payload
  },
  SETTOTALREGISTROS (state, payload) {
    state.registros = payload
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETLIMPARCOBRANCAS (state) {
    state.listValores = state.list = []
    state.registros = state.countPage = 0
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  }
}

const actions = {
  async getCobrancas ({ commit }, payload) {
    commit('SETLIMPARCOBRANCAS')
    commit('SETFILTROS', payload)
    let data = await cobrancas.getCobrancas(payload)
    commit('SETCOBRANCAS', data.instancia.list.cobrancas)
    commit('SETVALORES', data.instancia.list.cobrancaValores)
    commit('SETTOTALREGISTROS', data.instancia.registros)
    commit('SETPAGINATE', data.instancia.pages)
  },
  async getCobrancasFiltro ({ commit }) {
    commit('SETLIMPARCOBRANCAS')
    let data = await cobrancas.getCobrancas(state.filtros)
    commit('SETCOBRANCAS', data.instancia.list.cobrancas)
    commit('SETVALORES', data.instancia.list.cobrancaValores)
    commit('SETTOTALREGISTROS', data.instancia.registros)
  },
  async getTodasCobrancas ({ commit }) {
    commit('SETLIMPARCOBRANCAS')
    let data = await cobrancas.getTodasCobrancasComTotalizador(state.filtros)
    commit('SETCOBRANCAS', data.instancia.cobrancas)
    commit('SETVALORES', data.instancia.cobrancaValores)
    if (data.instancia.cobrancas) {
      commit('SETTOTALREGISTROS', data.instancia.cobrancas.length)
    }
  },
  async getTodasCobrancasExportar ({ commit }) {
    let resultCobrancas = await cobrancas.getTodasCobrancasSemTotalizador(state.filtros)
    return resultCobrancas.instancia
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getCobrancas', state.filtros)
  },
  async calculaBonificacao ({ commit }, payload) {
    try {
      return cobrancas.getCalculaBonificacao(payload)
    } catch (e) {
      return e
    }
  },
  async salvaBonificacao ({ commit }, payload) {
    try {
      return cobrancas.salvaBonificacao(payload)
    } catch (e) {
      return e
    }
  },
  async excluirCobranca ({ commit }, payload) {
    return cobrancas.ExcluirCobranca(payload)
  },
  verificarCobranca: function ({commit}, payload) {
    return cobrancas.verificarCobranca(payload)
  },
  pagarCobranca: function ({ commit }, payload) {
    return cobrancas.pagarCobranca(payload)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/cobrancas.js